/**
 * @file index.tsx
 *
 * @fileoverview Position something fixed within the page.
 */

import React from "react";
import styles from "./Fixed.module.scss";

export interface PositionFixedProps {
  /**
   * Top position for the element.
   */
  top?: string;
  /**
   * Bottom position for the element.
   */
  bottom?: string;
  /**
   * Right position for the element.
   */
  right?: string;
  /**
   * Left position for the element.
   */
  left?: string;
  /**
   * Z-index for the element.
   */
  zIndex?: number;
  /**
   * Content to be inserted inside the fixed element.
   */
  children?: React.ReactNode;
}

/**
 * Positions an element fixed on the page.
 */
export const FixedElement = ({
  top = "auto",
  bottom = "1rem",
  right = "1rem",
  left = "auto",
  zIndex = 10,
  children,
}: PositionFixedProps) => {
  return (
    <div
      className={styles.fixed}
      style={{
        top,
        bottom,
        right,
        left,
        zIndex,
      }}
    >
      {children}
    </div>
  );
};

export default FixedElement;
